import { always, compose, cond, converge, and, T, not } from 'ramda';

import { INVALID_COUPON_PATH, REGISTER_PATH } from 'app/router/constants/paths';
import {
  isEligibleForFreeTrial,
  isUserAuthenticated,
} from 'app/features/user/selectors';
import { isCouponValid } from 'app/features/couponCampaign/selectors';
import { freeTrialUrl } from 'app/features/checkout/selectors';
import { buildUrl } from 'app/router/helpers/buildUrl';

const isEligibleAndCouponIsValid = converge(and, [
  isCouponValid,
  isEligibleForFreeTrial,
]);

const ctaLink = cond([
  [compose(not, isUserAuthenticated), always(REGISTER_PATH)],
  [isEligibleAndCouponIsValid, freeTrialUrl],
  [T, always(buildUrl(INVALID_COUPON_PATH))],
]);

export { ctaLink };
